import { isEmpty } from 'lodash'

import { SpecSheetQuestion } from '../../models/specSheet'

export const isHeaderQuestion = (question: SpecSheetQuestion): boolean => {
    if (question.ExtraFields) {
        return question.ExtraFields.some((f) => f.Key === 'SpecSheetGroupStyle' && f.Value === 'Header')
    }

    return false
}

export const getAnswerText = (question: SpecSheetQuestion): string | undefined => {
    let answerText: string | undefined

    if (question.QuestionType === 'FreeEntry') {
        answerText = question.SelectedAnswerID
    } else if (question.Answers) {
        answerText = question.Answers.find((answer) => answer.ID === question.SelectedAnswerID)?.Text
    }

    if (!isEmpty(answerText)) {
        return answerText
    }

    return undefined
}
